import replaceWithMarkup from "../utils/replaceWithMarkup";
import { getPostsMarkup } from '../endpoints/query/getPosts';

/**
 *
 * Loads custom post type posts on Load More button click (adweek.com/sponsored archive uses this )
 *
 * @param {string} morePostsTrigger          Query string for triggering the loading and markup of posts.
 * @param {string} replaceWithPosts          Query string for node that new posts will replace.
 * @param {string} post_type                 Name of the post_type
 * @param {number} page                      Pagination index.
 */
export default function getCustomPostTypePosts (morePostsTrigger, replaceWithPosts, post_type, page) {
    const trigger = document.querySelector(morePostsTrigger);
    const anchor = trigger?.querySelector('a') ?? null;

    if (!trigger || !anchor) {
        adw.ENVIRONMENT === 'dev' && console.log("No trigger or anchor found for selector: " + morePostsTrigger + "");
        return;
    }

    trigger.addEventListener('click', async function (e) {
        e.preventDefault();

        const originalWrapper = anchor.innerHTML;
        anchor.innerHTML = '<div class="la-ball-pulse la-dark la-sm"><div></div><div></div><div></div></div>';
        const markupType = post_type === 'event' ? 'teaser_partner_more_grid' : 'index_item';

        const nextContent = await getPostsMarkup(post_type, page, 10, markupType);
        const reinitialize = (nextContent !== '');
        anchor.innerHTML = originalWrapper;

        replaceWithMarkup(trigger, nextContent, replaceWithPosts, reinitialize);

        reinitialize && getCustomPostTypePosts(morePostsTrigger, replaceWithPosts, post_type, ++page);
    }, { once: true });
}
